import ReactDOM from "react-dom"
import React, { FC } from "react"
import { toast } from "react-toastify"
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"

import { Loading } from "../../components/utils/Loading"
import { Thematic } from '../../components/utils/Thematic'

interface Props {
    status: any,
    header: any,
    show: boolean,
    contents: any,
    showOrHide: any,
    formAction: any,
    posting: boolean,
    formHandler: (e: any) => void,
    phase?: {
        prevHandler: () => void,
        prev: any,
        next: any,
    },
    error?: {
        title: string,
        message: any,
    },
}

export const SplitScreenModal: FC<Props> = ({ show, showOrHide, formHandler, posting, contents, formAction, status, error, header, phase = undefined }) => {
    const onCloseModal = () => {
        if (!posting) {
            showOrHide()
            return
        }

        let toastText = 'Cannot dismiss. Current operation is still in progress'

        toast.warning(toastText, {
            position: "top-right",
            autoClose: 7000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    return ReactDOM.createPortal(
        <Dialog open={show} onClose={onCloseModal} className="relative z-20">
            <DialogBackdrop transition className="fixed inset-0 bg-slate-500 dark:bg-slate-700/70 backdrop-blur-sm bg-opacity-65 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" />

            <div className="fixed inset-0 z-10 w-screen h-screen overflow-y-auto">
                <div className="flex h-full items-end justify-center w-full text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden bg-white dark:bg-slate-800 text-left shadow-xl w-full transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <Thematic>
                            <div className="absolute top-0 md:right-2 w-full md:w-auto z-20">
                                <div className="md:px-2 px-2 md:py-2 py-1.5 md:bg-inherit dark:md:bg-inherit bg-gray-100 dark:bg-gray-900/80 md:backdrop-blur-none backdrop-blur-sm bg-opacity-65 w-full flex flex-row-reverse">
                                    <button
                                        onClick={showOrHide}
                                        className="flex items-center justify-center w-8 h-8 rounded-md transition-colors bg-slate-200 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:bg-sky-900/30 dark:hover:text-gray-200 cursor-pointer focus:outline-none" aria-label="Close">
                                        <svg className="w-5 h-5 mb-1 mr-1 block" fill="none" viewBox="0 0 20 20" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <div className="wrapper md:justify-center md:items-center md:align-middle align-baseline w-full md:overflow-auto md:h-screen h-auto text-sm text-stone-600">
                                <section className="md:h-screen w-full h-screen lg:max-w-[1024px] md:w-full flex md:items-center md:justify-center ">
                                    {
                                        status === 'rejected' ? (
                                            <>

                                            </>
                                        ) : status === 'fulfilled' ? (
                                            <form className="flex md:flex-row flex-col align-middle items-center w-full h-screen md:pb-0 overflow-y-auto md:overflow-hidden" onSubmit={formHandler}>
                                                {/* Small Section */}
                                                <div className="lg:basis-2/5 md:basis-1/3 flex-none md:flex flex-col md:h-screen py-3 md:py-0 md:bg-inherit bg-gray-100">
                                                    <div className="h-8 w-full flex flex-row-reverse flex-none">
                                                        <button type="button" className="md:hidden flex flex-col align-middle justify-center rounded-md text-gray-800 dark:text-gray-200 hover:text-gray-800 focus:outline-none w-8 h-full"
                                                            onClick={undefined}>
                                                            <span className="fas fa-times border-none text-lg"></span>
                                                            <span className="sr-only text-sm ml-3">Close panel</span>
                                                        </button>
                                                    </div>

                                                    <div className="w-full md:flex-grow md:pt-3 px-4 border-r">
                                                        {
                                                            header
                                                        }
                                                    </div>

                                                    <div className="w-full flex-none pb-5 hidden md:block">
                                                        <button type="button" onClick={onCloseModal} className="w-auto min-w-28 disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-none px-3 py-1.5 text-slate-600 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 hover:underline hover:cursor-pointer focus:outline-none">
                                                            <span>Cancel</span>
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* Large Section */}
                                                <div className="lg:basis-3/5 md:basis-3/4 flex flex-grow flex-col md:h-screen w-full h-full md:space-y-3">
                                                    <div className="h-8 w-full hidden md:flex flex-row-reverse"></div>

                                                    <div className="w-full flex-grow pt-3 px-4 md:overflow-y-auto">
                                                        {
                                                            contents
                                                        }
                                                    </div>

                                                    <div className="flex-none w-full pb-5 px-4">
                                                        {
                                                            phase ? (
                                                                <div className="flex flex-row-reverse gap-x-3 align-middle">
                                                                    <button type="submit" className="w-auto min-w-28 disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-md px-3 py-1.5 bg-orange-500 dark:bg-orange-600 text-white hover:bg-orange-600 dark:hover:bg-orange-500 focus:outline-none flex justify-center items-center gap-x-2">
                                                                        {
                                                                            posting ? (
                                                                                <span className="flex flex-row items-center h-5 justify-center">
                                                                                    <i className="fa-duotone fa-spinner-third fa-xl fa-spin"></i>
                                                                                </span>
                                                                            ) : (
                                                                                <>
                                                                                    <span>{formAction}</span>

                                                                                    {
                                                                                        phase?.next ? (
                                                                                            <i className="fa-regular fa-chevron-right"></i>
                                                                                        ) : (
                                                                                            <>
                                                                                                <svg width="24" height="24" viewBox="0 0 24 24" className="transition-all duration-300">
                                                                                                    <circle cx="12" cy="12" r="10" className="stroke-white dark:fill-none" strokeWidth="2" fill="none" />
                                                                                                    <path d="M8 12l3 3l5-5" className="stroke-white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                </svg>
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }
                                                                    </button>

                                                                    <button type="button" onClick={phase.prevHandler} disabled={posting} className={`w-auto min-w-28 ${phase.prev === null ? 'hidden' : ''} disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-none px-3 py-1.5 bg-inherit text-orange-600 hover:text-orange-700 dark:text-orange-300 dark:hover:text-orange-200 focus:outline-none flex justify-center items-center align-middle gap-x-2.5 dark:disabled:text-orange-500 dark:disabled:hover:bg-slate-700 disabled:text-orange-400`}>
                                                                        <i className="fa-regular fa-chevron-left"></i>
                                                                        <span>Previous</span>
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className="flex flex-row-reverse gap-x-3 align-middle">
                                                                    <button type="submit" className="w-auto min-w-24 justify-center disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-sm px-3 py-1.5 bg-orange-500 dark:bg-orange-600 text-white hover:bg-orange-600 dark:hover:bg-orange-500 focus:outline-none">
                                                                        {
                                                                            posting ? (
                                                                                <span className="flex flex-row items-center h-5 justify-center">
                                                                                    <i className="fa-duotone fa-spinner-third fa-xl fa-spin"></i>
                                                                                </span>
                                                                            ) : (
                                                                                formAction
                                                                            )
                                                                        }
                                                                    </button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </form>
                                        ) : (
                                            <div className="h-screen md:h-auto flex flex-col align-middle justify-center items-center md:px-0 px-6">
                                                <div className="py-2 px-6 bg-white dark:bg-slate-800 w-full rounded-lg">
                                                    <Loading />
                                                </div>
                                            </div>
                                        )
                                    }
                                </section>
                            </div>
                        </Thematic>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>,
        document.getElementById('root')
    )
}